// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"Ka","modalContent":"La","header":"Ma","close":"Na"};